import { render, staticRenderFns } from "./link-existing-tasks-panel.vue?vue&type=template&id=38b2d5d0&"
import script from "./link-existing-tasks-panel.vue?vue&type=script&lang=ts&"
export * from "./link-existing-tasks-panel.vue?vue&type=script&lang=ts&"
import style0 from "./link-existing-tasks-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports